// extracted by mini-css-extract-plugin
export default {"root":"_3YlDW","dd":"_2rhR8","hype":"VngZM"};